import { trimPipes, milOrBil, sanitize, isEmpty, truncateString } from "../../_js/common/_util";

'use strict';

export default class Company {
    constructor() { }

    generateCompanyHTML(el) {
        let companyHTML = '';

        companyHTML += `<div class="company">
                            <div class="company-inner">
                            <div class="company-top">
                            <div class="company__header sidebar__wrap">`;
        companyHTML +=         `<div class="company__details ">`;

        companyHTML +=          `<a href="#/company/${sanitize(el[3])}" class="company__name">${el[3]}</a>`;
        // if (isEmpty(el[4])) {
        //     companyHTML +=          `<a href="#/company/${sanitize(el[3])}" class="company__name">${el[3]}</a>`;
        // } else {
        //     companyHTML +=          `<a href="#/company/${sanitize(el[3])}" class="company__name">${el[3]} <span>(${el[4]})</span></a>`;
        // }

        companyHTML +=          `</div>`;

        companyHTML +=          `<a class="company__logo sidebar__logo" href="#/company/${sanitize(el[3])}">${el[8]}</a>
                            </div>`;

        if (!isEmpty(el[4]) || !isEmpty(el[1])) {

            companyHTML += `        <ul>`;

            if (isEmpty(el[5])) {
                companyHTML += `        <li class="-networth"><div>Market value</div> - </li>`;
            } else {
                companyHTML += `        <li class="-networth"><div>Market value</div>${ milOrBil(el[5]) } USD</li>`;
            }

            if (!isEmpty(el[1])) {
                companyHTML += `        <li class="-type"><div>Type of company</div>${ trimPipes(el[1]) }</li>`;
            }

            if (!isEmpty(el[6])) {
                if (!isEmpty(el[7])) {
                    companyHTML += `    <li class="-ceo"><div>Founder / CEO</div>${el[6]} ${el[7]}</li>`;
                } else {
                    companyHTML += `    <li class="-ceo"><div>Founder / CEO</div>${el[6]}</li>`;
                }
            }

            if (!isEmpty(el[2])) {
                companyHTML += `       <li class="-ownership"><div>Ownership structure</div>${trimPipes(el[2])}</li>`;
            }

            companyHTML +=     `    </ul>`;
        }
        companyHTML +=          `</div>`;

        companyHTML +=      `<div class="company-bottom">`;
        companyHTML +=      `<div class="company__info">
                                <div class="company__info__top">
                                    <p>${truncateString(el[9], 130)}</p>
                                </div>
                                <a class="company__link" href="#/company/${sanitize(el[3])}">Read More</a>
                            </div>`;

        companyHTML +=          `</div>`;
        companyHTML +=          `</div>`;
        companyHTML +=          `</div>`;
        return companyHTML;
    }
}
